import type { EstateAnalysis } from './analytics';

export type IsochronesData = NonNullable<EstateAnalysis['isochrones']>['data'][number]['data'];

export const useIsochrones = (estateAnalysis: EstateAnalysis) => {
  const data: Record<string, Record<string, IsochronesData>> = (
    estateAnalysis.isochrones?.data || []
  ).reduce<Record<string, Record<number, IsochronesData>>>((acc, dt) => {
    if (!acc[dt.mode]) {
      acc[dt.mode] = {};
    }
    acc[dt.mode][dt.cutoff] = dt.data;
    return acc;
  }, {});

  return { data };
};
